import React from 'react';
import { format, startOfWeek, endOfWeek, addDays, isSameDay, isToday } from 'date-fns';

const WeekView = ({ currentDate, events, keyTimes, onEventClick, onNewEvent }) => {
  // Get the start and end of the current week (Monday to Friday)
  const weekStart = startOfWeek(currentDate, { weekStartsOn: 1 }); // Monday
  const weekEnd = endOfWeek(currentDate, { weekStartsOn: 1 }); // Friday

  // Generate week days (Monday to Friday only)
  const generateWeekDays = () => {
    const days = [];
    let day = weekStart;
    
    while (day <= weekEnd) {
      // Only include Monday to Friday (1-5)
      const dayOfWeek = day.getDay();
      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        days.push(day);
      }
      day = addDays(day, 1);
    }
    
    return days;
  };

  const weekDays = generateWeekDays();
  

  // Get events for a specific time slot
  const getEventsForTimeSlot = (day, time) => {
    return events.filter(event => {
      if (!isSameDay(new Date(event.date), day)) return false;
      if (!event.start_time) return false;
      
      const eventTime = event.start_time.substring(0, 5); // Get HH:MM
      return eventTime === time;
    });
  };

  const dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  return (
    <div className="week-view-container">
      <div className="week-header">
        <h2 className="week-title">
          Week of {format(weekStart, 'MMM d')} - {format(weekEnd, 'MMM d, yyyy')}
        </h2>
      </div>

      <div className="week-grid">
        {/* Day Headers */}
        <div className="week-day-headers">
          <div className="time-column-header"></div>
          {weekDays.map((day, index) => (
            <div key={day.toISOString()} className="week-day-header">
              <div className="day-name">{dayNames[index]}</div>
              <div className={`day-number ${isToday(day) ? 'today' : ''}`}>
                {format(day, 'd')}
              </div>
            </div>
          ))}
        </div>

        {/* Time Slots */}
        {keyTimes.map(timeSlot => (
          <div key={timeSlot.id} className="week-time-row">
            <div className="time-label">
              {timeSlot.time}
            </div>
            {weekDays.map(day => {
              const dayEvents = getEventsForTimeSlot(day, timeSlot.time);
              const isCurrentDay = isToday(day);
              
              return (
                <div
                  key={`${day.toISOString()}-${timeSlot.time}`}
                  className={`week-time-slot ${isCurrentDay ? 'today' : ''}`}
                  onClick={() => onNewEvent(day)}
                >
                  {dayEvents.map(event => {
                    // Determine class from event title
                    let classCode = '';
                    if (event.title) {
                      const title = event.title.toLowerCase();
                      if (title.includes('maths intervention')) {
                        classCode = 'class-intervention';
                      } else if (title.includes('7w/ma2')) {
                        classCode = 'class-7w-ma2';
                      } else if (title.includes('9w/ma2')) {
                        classCode = 'class-9w-ma2';
                      } else if (title.includes('9e/ma3b')) {
                        classCode = 'class-9e-ma3b';
                      } else if (title.includes('8e/ma1')) {
                        classCode = 'class-8e-ma1';
                      } else if (title.includes('8w/ma1')) {
                        classCode = 'class-8w-ma1';
                      }
                    }
                    
                    return (
                      <div
                        key={event.id}
                        className={`week-event-item ${classCode}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          onEventClick(event);
                        }}
                        title={event.title}
                      >
                        <div className="event-title">{event.title}</div>
                        <div className="event-room">{event.room}</div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeekView;
